import React from "react";
import trans from "../../../../utils";
import PopupBodyItem from "../../../Helpers/Popup/PopupParts/PopupBodyItem";
import { formatDate } from "../../../../JsHelpers/DateFormat";
import { Checkbox, Table, Tag } from "antd";
import { useGetAllPermissionsQuery } from "../../../../Redux/service/Roles&Permissions/RolesPermissions";

export default function RolesInf({ values = {} }) {
	const getValue = (value, defaultValue = "-----") =>
		value ? value : defaultValue;

	const {
		name = "",
		description = "",
		userType = "",
		isActive = "",
		expiry = "",
		rolePermissions = [],
		createdBy = "",
		updatedBy = "",
		createdAt = "",
		updatedAt = "",
	} = values;
	const formattedCreatedAt = createdAt
		? formatDate(createdAt).formattedDate
		: "-----";
	const formattedUpdatedAt = updatedAt
		? formatDate(updatedAt).formattedDate
		: "-----";
	const formattedExpiration = expiry
		? formatDate(expiry).formattedDate
		: "-----";

	const columns = [
		{
			title: trans("Name"),
			dataIndex: "name",
			key: "name",
		},
		{
			title: trans("Resource"),
			dataIndex: "resources",
			key: "resources",
		},
		{
			title: trans("Actions"),
			dataIndex: "actions",
			key: "actions",
		},
	];
	return (
		<div>
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("Basic Information")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem title={trans("Name")} item={getValue(name)} />
						<PopupBodyItem
							title={trans("User Type")}
							item={getValue(userType)}
						/>
						<PopupBodyItem
							title={trans("Status")}
							item={getValue(
								isActive ? (
									<Tag color="green">{trans("Active")}</Tag>
								) : (
									<Tag color="red">{trans("Inactive")}</Tag>
								)
							)}
						/>

						<PopupBodyItem
							title={trans("Created By")}
							item={getValue(createdBy?.name || "- - - -")}
						/>
						<PopupBodyItem
							title={trans("updated by")}
							item={getValue(updatedBy?.name || "- - - -")}
						/>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem
							title={trans("Description")}
							item={getValue(description)}
						/>
						<PopupBodyItem
							title={trans("Permissions")}
							item={getValue(rolePermissions?.length)}
						/>

						<PopupBodyItem
							title={trans("Role Expiration Date")}
							item={getValue(formattedExpiration)}
						/>
						<PopupBodyItem
							title={trans("Created At")}
							item={getValue(formattedCreatedAt)}
						/>
						<PopupBodyItem
							title={trans("updated at")}
							item={getValue(formattedUpdatedAt)}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
